import React, { useEffect, useState } from "react";
import { Table, Spin, message, Button, Row, Col, Typography, Divider, Modal, Checkbox, Card, Avatar } from "antd";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import _ from "lodash";
import {
  TruckOutlined,
  UserOutlined,
  PhoneOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  HomeOutlined,
  IdcardOutlined
} from "@ant-design/icons";
import CustomModal from "../../components/common/CustomModal";

const { Text } = Typography;

const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});

const RecepcionDevoluciones = () => {
  const { idruta } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [facturasAgrupadas, setFacturasAgrupadas] = useState([]);
  const [choferInfo, setChoferInfo] = useState(null);
  const [messageApi, contextHolder] = message.useMessage();

  const [modalVisible, setModalVisible] = useState(false);
  const [facturaSeleccionada, setFacturaSeleccionada] = useState(null);
  const [confirmChecked, setConfirmChecked] = useState(false);

  const [modalProductoVisible, setModalProductoVisible] = useState(false);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [confirmCheckedProducto, setConfirmCheckedProducto] = useState(false);

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  const cargarFacturas = async () => {
    try {
      const res = await Axios.post("sd/getProdEnDevolucionByRuta", { idruta }, { headers });
      const productos = res.data.data || [];

      // Si no hay productos, cerrar la ruta automáticamente
      if (productos.length === 0) {
        Axios.post("sd/terminarRuta", {
          idruta,
          idestadoruta: 4,
        }, { headers })
          .then(() => {
            messageApi.success("Ruta cerrada automáticamente");
            navigate("/routes");
          })
          .catch(() => {
            messageApi.error("Error al cerrar la ruta automáticamente");
          });
        return;
      }

      const agrupado = _.groupBy(productos, "idinvoice");

      const facturas = Object.keys(agrupado).map((idinvoice) => {
        const items = agrupado[idinvoice];
        const first = items[0];

        return {
          idfactura: idinvoice,
          codigo: first.codigo,
          cliente: `${first.nombredestinatario} ${first.papelldestinatario} ${first.sapelldestinatario}`,
          telefonoCliente: first.telefonodestinatario,
          direccionCliente: first.direcciondestinatario,
          municipioCliente: first.cmunicipality,
          provinciaCliente: first.cprovince,
          estado: first.estadoinvoice,
          productos: items.map((p) => ({
            id: p.idproductinvoice,
            nombre: p.namegood,
            cantidad: p.quantity,
            estado: p.estadoproducto,
          })),
        };
      });

      if (productos.length > 0) {
        const f = productos[0];
        setChoferInfo({
          nombre: `${f.nombrechofer} ${f.papellchofer} ${f.sapellchofer}`,
          telefono: f.telefonochofer,
          carnet: f.carnetchofer,
          matricula: f.matricula,
        });
      }

      setFacturasAgrupadas(facturas);
    } catch {
      messageApi.error("Error al cargar las facturas");
    }
  };

  useEffect(() => {
    setLoading(true);
    cargarFacturas().finally(() => setLoading(false));
  }, [idruta]);

  const confirmarRecepcionProducto = (producto) => {
    setProductoSeleccionado(producto);
    setConfirmCheckedProducto(false);
    setModalProductoVisible(true);
  };

  // const recepcionarProducto = async () => {
  //   if (!productoSeleccionado) return;
  //   try {
  //     setLoading(true);
  //     setModalProductoVisible(false);

  //     await Axios.post(
  //       "sd/updateEstadoProducto",
  //       {
  //         idproductinvoice: productoSeleccionado.id,
  //         idestadoproducto: 4,
  //       },
  //       { headers }
  //     );

  //     messageApi.success(`Producto "${productoSeleccionado.nombre}" recepcionado correctamente`);
  //     await cargarFacturas();
  //   } catch (error) {
  //     console.error(error);
  //     messageApi.error("Error al recepcionar el producto");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const recepcionarProducto = async () => {
    if (!productoSeleccionado) return;

    // Buscar la factura asociada al producto seleccionado
    const factura = facturasAgrupadas.find(f =>
      f.productos.some(p => p.id === productoSeleccionado.id)
    );

    if (!factura) {
      messageApi.error("No se encontró la factura del producto");
      return;
    }

    try {
      setLoading(true);
      setModalProductoVisible(false);

      await Axios.post(
        "sd/recepcionarProducto", // ✅ nuevo endpoint
        {
          idproductinvoice: productoSeleccionado.id,
          idestadoproducto: 4,
          idinvoice: factura.idfactura, // ✅ se envía la factura relacionada
        },
        { headers }
      );

      messageApi.success(`Producto "${productoSeleccionado.nombre}" recepcionado correctamente`);
      await cargarFacturas();
    } catch (error) {
      console.error(error);
      messageApi.error("Error al recepcionar el producto");
    } finally {
      setLoading(false);
    }
  };


  const confirmarRecepcionFactura = (factura) => {
    setFacturaSeleccionada(factura);
    setConfirmChecked(false);
    setModalVisible(true);
  };

  const recepcionarFactura = async () => {
    if (!facturaSeleccionada) return;
    const ids = facturaSeleccionada.productos.map((p) => p.id);
    try {
      setLoading(true);
      setModalVisible(false);

      await Axios.post(
        "sd/recepcionarFactura",
        {
          idinvoice: facturaSeleccionada.idfactura,
          idproductinvoice: ids,
          idestadoproducto: 4,
        },
        { headers }
      );

      messageApi.success(`Factura ${facturaSeleccionada.codigo} recepcionada correctamente`);
      await cargarFacturas();
    } catch (error) {
      console.error(error);
      messageApi.error("Error al recepcionar la factura");
    } finally {
      setLoading(false);
    }
  };

  const generarFiltros = (data, campo) => {
    const únicos = _.uniqBy(data, campo);
    return únicos.map((item) => ({
      text: item[campo],
      value: item[campo],
    }));
  };

  const productosColumns = [
    {
      title: "Producto",
      dataIndex: "nombre",
    },
    {
      title: "Cantidad",
      dataIndex: "cantidad",
    },
    {
      title: "Estado",
      dataIndex: "estado",
    },
    {
      title: "Acción",
      render: (_, record) =>
        record.estado !== "Recepcionado" ? (
          <Button
            type="primary"
            onClick={() => confirmarRecepcionProducto(record)}
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              border: "none",
              borderRadius: "8px",
              height: "36px",
              fontWeight: "500",
              boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
            }}
            icon={<CheckCircleOutlined />}
          >
            Recepcionar
          </Button>
        ) : (
          <Text style={{ color: "#52c41a", fontWeight: "500" }}>
            <CheckCircleOutlined style={{ marginRight: "4px" }} />
            Recepcionado
          </Text>
        ),
    },
  ];

  const facturaColumns = [
    {
      title: "Código",
      dataIndex: "codigo",
      filters: generarFiltros(facturasAgrupadas, "codigo"),
      onFilter: (value, record) => record.codigo === value,
    },
    {
      title: "Cliente",
      dataIndex: "cliente",
      filters: generarFiltros(facturasAgrupadas, "cliente"),
      onFilter: (value, record) => record.cliente === value,
    },
    {
      title: "Teléfono",
      dataIndex: "telefonoCliente",
      filters: generarFiltros(facturasAgrupadas, "telefonoCliente"),
      onFilter: (value, record) => record.telefonoCliente === value,
    },
    {
      title: "Dirección",
      dataIndex: "direccionCliente",
      filters: generarFiltros(facturasAgrupadas, "direccionCliente"),
      onFilter: (value, record) => record.direccionCliente === value,
    },
    {
      title: "Municipio",
      dataIndex: "municipioCliente",
      filters: generarFiltros(facturasAgrupadas, "municipioCliente"),
      onFilter: (value, record) => record.municipioCliente === value,
    },
    {
      title: "Provincia",
      dataIndex: "provinciaCliente",
      filters: generarFiltros(facturasAgrupadas, "provinciaCliente"),
      onFilter: (value, record) => record.provinciaCliente === value,
    },
    {
      title: "Estado",
      dataIndex: "estado",
      filters: generarFiltros(facturasAgrupadas, "estado"),
      onFilter: (value, record) => record.estado === value,
    },
    {
      title: "Acción",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => confirmarRecepcionFactura(record)}
          style={{
            background: "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)",
            border: "none",
            borderRadius: "8px",
            height: "36px",
            fontWeight: "500",
            boxShadow: "0 2px 8px rgba(82, 196, 26, 0.3)",
          }}
          icon={<CheckCircleOutlined />}
        >
          Recepcionar todos
        </Button>
      ),
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ padding: 20 }}>
        {contextHolder}

        <div
          style={{
            backgroundColor: "#667eea",
            borderRadius: "12px",
            padding: "24px",
            marginBottom: "24px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
            border: "1px solid rgba(255,255,255,0.1)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "16px" }}>
            <TruckOutlined
              style={{
                fontSize: "32px",
                color: "white",
                marginRight: "16px",
                background: "linear-gradient(135deg, #ffd700 0%, #ffed4e 100%)",
                padding: "12px",
                borderRadius: "50%",
                boxShadow: "0 4px 16px rgba(255,215,0,0.3)",
              }}
            />
            <h1
              style={{
                color: "white",
                fontSize: "28px",
                fontWeight: "600",
                margin: 0,
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
              }}
            >
              Recepción de Productos
            </h1>
          </div>
          <div style={{ textAlign: "center" }}>
            <Text
              style={{
                color: "rgba(255,255,255,0.9)",
                fontSize: "16px",
                fontWeight: "500",
                textShadow: "0 1px 2px rgba(0,0,0,0.2)",
              }}
            >
              Facturas con productos - En devolución
            </Text>
          </div>
        </div>

        {choferInfo && (
          <Card
            style={{
              marginBottom: "24px",
              borderRadius: "12px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
              border: "1px solid #e8e8e8",
            }}
            title={
              <div style={{ display: "flex", alignItems: "center" }}>
                <Avatar
                  style={{
                    backgroundColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    marginRight: "12px",
                    background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  }}
                  icon={<UserOutlined />}
                />
                <Text
                  style={{
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#2c3e50",
                  }}
                >
                  Información del Chofer
                </Text>
              </div>
            }
          >
            <Row gutter={[24, 16]}>
              <Col xs={24} sm={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <UserOutlined style={{ marginRight: "8px", color: "#667eea" }} />
                  <Text strong style={{ color: "#2c3e50" }}>Nombre:</Text>
                </div>
                <Text style={{ fontSize: "16px", color: "#4a5568" }}>{choferInfo.nombre}</Text>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <IdcardOutlined style={{ marginRight: "8px", color: "#667eea" }} />
                  <Text strong style={{ color: "#2c3e50" }}>Carnet:</Text>
                </div>
                <Text
                  style={{
                    fontSize: "16px",
                    color: "#4a5568",
                    cursor: "pointer",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "background-color 0.2s"
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(choferInfo.carnet);
                    messageApi.success("Carnet copiado al portapapeles");
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                  title="Click para copiar"
                >
                  {choferInfo.carnet}
                </Text>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <PhoneOutlined style={{ marginRight: "8px", color: "#667eea" }} />
                  <Text strong style={{ color: "#2c3e50" }}>Teléfono:</Text>
                </div>
                <Text
                  style={{
                    fontSize: "16px",
                    color: "#4a5568",
                    cursor: "pointer",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    transition: "background-color 0.2s"
                  }}
                  onClick={() => {
                    navigator.clipboard.writeText(choferInfo.telefono);
                    messageApi.success("Teléfono copiado al portapapeles");
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = "#f5f5f5"}
                  onMouseLeave={(e) => e.target.style.backgroundColor = "transparent"}
                  title="Click para copiar"
                >
                  {choferInfo.telefono}
                </Text>
              </Col>
              <Col xs={24} sm={12} md={6}>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                  <TruckOutlined style={{ marginRight: "8px", color: "#667eea" }} />
                  <Text strong style={{ color: "#2c3e50" }}>Matrícula:</Text>
                </div>
                <Text style={{ fontSize: "16px", color: "#4a5568" }}>{choferInfo.matricula}</Text>
              </Col>
            </Row>
          </Card>
        )}

        <Card
          style={{
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            border: "1px solid #e8e8e8",
          }}
          title={
            <div style={{ display: "flex", alignItems: "center" }}>
              <FileTextOutlined
                style={{
                  fontSize: "20px",
                  color: "#667eea",
                  marginRight: "12px",
                }}
              />
              <Text
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#2c3e50",
                }}
              >
                Facturas y Productos en Devolución
              </Text>
            </div>
          }
        >
          <Table
            dataSource={facturasAgrupadas}
            columns={facturaColumns}
            rowKey="idfactura"
            expandable={{
              expandedRowRender: (record) => (
                <Table
                  columns={productosColumns}
                  dataSource={record.productos}
                  rowKey="id"
                  pagination={false}
                  size="small"
                />
              ),
              rowExpandable: (record) => record.productos.length > 0,
            }}
            pagination={{
              pageSize: 10,
              position: ["bottomCenter"],
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} elementos`,
            }}
          />
        </Card>

        <CustomModal
          title="Confirmar Recepción de Factura"
          open={modalVisible}
          onOk={recepcionarFactura}
          onCancel={() => setModalVisible(false)}
          okButtonProps={{ disabled: !confirmChecked }}
          okText="Recepcionar"
          cancelText="Cancelar"
          icon={<FileTextOutlined />}
          headerColor="#52c41a"
          footer={
            <div style={{
              textAlign: 'center',
              padding: '16px 24px',
              borderTop: '1px solid #f0f0f0',
              marginTop: '24px'
            }}>
              <Button key="cancel" onClick={() => setModalVisible(false)} style={{marginRight: 12, height: '40px', borderRadius: '8px', fontWeight: '500'}}>
                Cancelar
              </Button>
              <Button
                key="submit"
                type="primary"
                onClick={recepcionarFactura}
                disabled={!confirmChecked}
                style={{
                  backgroundColor: "#52c41a",
                  border: "none",
                  borderRadius: "8px",
                  height: "40px",
                  fontWeight: "500",
                  boxShadow: "0 2px 8px rgba(82, 196, 26, 0.3)",
                }}
              >
                Recepcionar
              </Button>
            </div>
          }
        >
          <div style={{ padding: "16px 0" }}>
            <Text style={{ fontSize: "16px", color: "#4a5568", lineHeight: "1.6" }}>
              ¿Está seguro de que desea recepcionar <Text strong style={{ color: "#2c3e50" }}>todos los productos</Text> de la factura <Text strong style={{ color: "#2c3e50" }}>{facturaSeleccionada?.codigo}</Text>?
            </Text>
            <div style={{ marginTop: "20px" }}>
              <Checkbox
                checked={confirmChecked}
                onChange={(e) => setConfirmChecked(e.target.checked)}
                style={{ fontSize: "15px" }}
              >
                Sí, estoy de acuerdo y deseo continuar.
              </Checkbox>
            </div>
          </div>
        </CustomModal>

        <CustomModal
          title="Confirmar Recepción de Producto"
          open={modalProductoVisible}
          onOk={recepcionarProducto}
          onCancel={() => setModalProductoVisible(false)}
          okButtonProps={{ disabled: !confirmCheckedProducto }}
          okText="Recepcionar"
          cancelText="Cancelar"
          icon={<CheckCircleOutlined />}
          headerColor="#667eea"
          footer={
            <div style={{
              textAlign: 'center',
              padding: '16px 24px',
              borderTop: '1px solid #f0f0f0',
              marginTop: '24px'
            }}>
              <Button key="cancel" onClick={() => setModalProductoVisible(false)} style={{marginRight: 12, height: '40px', borderRadius: '8px', fontWeight: '500'}}>
                Cancelar
              </Button>
              <Button
                key="submit"
                type="primary"
                onClick={recepcionarProducto}
                disabled={!confirmCheckedProducto}
                style={{
                  backgroundColor: "#667eea",
                  border: "none",
                  borderRadius: "8px",
                  height: "40px",
                  fontWeight: "500",
                  boxShadow: "0 2px 8px rgba(102, 126, 234, 0.3)",
                }}
              >
                Recepcionar
              </Button>
            </div>
          }
        >
          <div style={{ padding: "16px 0" }}>
            <Text style={{ fontSize: "16px", color: "#4a5568", lineHeight: "1.6" }}>
              ¿Está seguro de que desea recepcionar el producto <Text strong style={{ color: "#2c3e50" }}>{productoSeleccionado?.nombre}</Text>?
            </Text>
            <div style={{ marginTop: "20px" }}>
              <Checkbox
                checked={confirmCheckedProducto}
                onChange={(e) => setConfirmCheckedProducto(e.target.checked)}
                style={{ fontSize: "15px" }}
              >
                Sí, estoy de acuerdo y deseo continuar.
              </Checkbox>
            </div>
          </div>
        </CustomModal>
      </div>
    </Spin>
  );
};

export default RecepcionDevoluciones;
